/** Maps claim action status to a MUI Chip color */
export function getActionStatusColor(status: string): 'default' | 'success' | 'warning' | 'error' | 'info' {
  switch (status) {
    case 'COMPLETED':
      return 'success';
    case 'FAILED':
      return 'error';
    case 'SKIPPED':
      return 'warning';
    case 'PROCESSING':
      return 'info';
    case 'PENDING':
    default:
      return 'default';
  }
}
